module.exports = __webpack_public_path__ + "static/media/privacy-policy.49d69320.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/security/privacy-policy.pdf
// module id = 543
// module chunks = 0